import React from "react";
import VisorPluginPlaceholder from "../../../_visor/components/canvas/VisorPluginPlaceholder";
import i18n from "i18next";
import { letterFromNumber } from "../../../common/common_tools";
import { shuffle } from "../../../common/common_tools";
import MultipleChoiceVisor from "../MultipleChoiceVisor";

import { compareNumbersLiterally } from "../../../core/visor/correction_functions";
/* eslint-disable react/prop-types */

export function MultipleChoice() {
  return {
    getRenderTemplate: function (state, props) {
      return <MultipleChoiceVisor state={state} props={props} />;
    },

    checkAnswer(current, correct) {
      return compareNumbersLiterally(current, correct);
    },
  };
}
/* eslint-enable react/prop-types */
